//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    toggleTopbar,
    switchNavColor,
    changeThemeColor,
    getCurrentThemeColor,
    getUserInfo,
    controlTopButton,
    cGoBack,
    getVersionInfoWithCallback,
    // isWhichVersion
    isWhichVersionNew
} from "@/util/const";
// 这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import "swiper/swiper-bundle.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { setAuthorization } from "../../axios/userInfo";

export default {
    name: "selectSkin",
    components: {
        swiper,
        swiperSlide,
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        },
    },
    data() {
        return {
            bgIndex: 1,
            preIndex: 1,
            text: {},
            listData: [
                {
                    title: this.$t("selectSkin.theme1.title"),
                    detail: this.$t("selectSkin.theme1.desc"),
                    index: 1,
                    show: true,
                },
                {
                    title: this.$t("selectSkin.theme3.title"),
                    detail: this.$t("selectSkin.theme3.desc"),
                    index: 3,
                    show: true,
                },
                {
                    title: this.$t("selectSkin.theme4.title"),
                    detail: this.$t("selectSkin.theme4.desc"),
                    index: 4,
                    show: true,
                },
                {
                    title: this.$t("selectSkin.theme5.title"),
                    detail: this.$t("selectSkin.theme5.desc"),
                    index: 5,
                    show: true,
                },
                {
                    title: this.$t("selectSkin.theme6.title"),
                    detail: this.$t("selectSkin.theme6.desc"),
                    index: 6,
                    show: true,
                }
            ],
            numList: [],
            swiperOption: {
                slidesPerView: 1.15,
                // spaceBetween: -1.5,
                centeredSlides: true,
                watchSlidesProgress: true,
                on: {
                    slideChange: () => {
                        let swiper = this.$refs.mySwiper.swiper;
                        let index = parseInt(
                            swiper.slides[swiper.activeIndex].getAttribute(
                                "data"
                            )
                        );
                        this.bgIndex = index;
                    },
                },
            },
            toast: false,
            saveIndex: 0,
            num: 1,
            showStatus: this.$route.query.showStatus
        };
    },
    methods: {
        previewSkin(index) {
            if (index === this.preIndex) return;
            let query = {
                title: "",
                index: "",
                oldIndex: this.preIndex,
                hideNavigationBar: true,
                showStatus:this.showStatus
            };
            this.listData.map((x) => {
                if (x.index === index) {
                    query.title = x.title;
                    query.index = x.index;
                }
            });
            console.log("query.title:",query.title,",query.index:",query.index,",query.oldIndex:",query.oldIndex,'query')
            this.$router.push({
                path: "/skinPreview",
                query,
            });
        },
        checkData(index) {
            this.$Loading(true);
            this.$http
                .postOther(
                    "/v1/api/ad/startpage/updateThemeCount",
                    {
                        oldThemeId: this.preIndex,
                        newThemeId: index,
                    },
                    true
                )
                .then((res) => {
                    this.$Loading(false);
                    this.toast = false;
                    if (res.data.header.resultCode === 0) {
                        this.preIndex = this.bgIndex;
                        this.bgIndex = index;
                        changeThemeColor(index);
                        this.$toast({ msg: this.$t("selectSkin.toast") });
                    } else {
                        this.$toast({ msg: this.$t("selectSkin.toast2") });
                    }
                })
                .catch((err) => {
                    this.$Loading(false);
                    this.toast = false;
                    this.$toast({ msg: this.$t("selectSkin.toast2") });
                });
        },
        toastClick(index) {
            this.saveIndex = index;
            this.toast = true;
        },
    },
    async created() {
        let that = this;
        window.getUserInfo = (obj) => {
            setAuthorization(obj.authorization);
            let data = {
                title: that.$t("selectSkin.theme2.title"),
                detail: that.$t("selectSkin.theme2.desc"),
                index: 2,
                show: false,
            };
            data.show =
                obj.user.isPrivilegeMember &&
                obj.user.isPrivilegeMember === true
                    ? true
                    : false;
            if (data.show) {
                that.listData.splice(1, 0, data);
            }
          let data2 = {
              title: that.$t("selectSkin.theme7.title"),
              detail: that.$t("selectSkin.theme7.desc"),
              index: 7,
              show: true
          }
            if(obj.user.userType === 50) {
              that.listData.push(data2)
            }
        };
        window.getCurrentThemeColorApi = (val) => {
            that.preIndex = parseInt(val);
            that.bgIndex = parseInt(val);
            that.listData.map((x, index) => {
                if (that.bgIndex === x.index) {
                    that.$refs.mySwiper.swiper.slideTo(index, 1000, false);
                }
            });
        };
        window.changeActivityNew = async () => {
            try {
                await history.go(-1);
                setTimeout(() => {
                    this.num = 2;
                }, 300);
            } catch (error) {
                alert(error)
            }
        };
        // 隐藏客户端状态栏
        toggleTopbar(0);

        // h5控制客户端导航栏字体颜色
        switchNavColor({ color: "FFFFFF" });
        let change = {
            backVisible: false,
            left1icon:
                "https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/whiteClose.png",
            left1link:
                "cmcchkh5action://callJSfunction?function=changeActivityNew()",
            right1icon:
                "https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/whiteRight.png",
            // right1link:
            //     "cmcchkh5action://callJSfunction?function=getModalBoxNew()",
            right1link: `openurl-modal://${location.origin}/activity/myCity/#/modalBox?index=3&hideNavigationBar=true&lang=${localStorage.getItem('lang')}`,
        };
        let change1 = {
            backVisible: false,
            left1icon:
                "https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/whiteClose.png",
            left1link:
                "cmcchkh5action://callJSfunction?function=changeActivityNew()"
        };
        if (isWhichVersionNew()) {
            //恢复合并的代码
            if(!this.$route.query.showStatus){
                controlTopButton(change);
            }else{
                controlTopButton(change1);
            }
        } else {
            controlTopButton(change1)
        }
        // 获取用户是否会员
        getUserInfo({ callbackName: "getUserInfo", needLogin: false });
        // 获取当前系统皮肤
        getCurrentThemeColor({ callback: "getCurrentThemeColorApi" });
        document.title = this.$t("selectSkin.title");
        let conut = await this.$http.get("/v1/api/ad/startpage/themeCount");
        if (conut.data.header.resultCode === 0) {
            if (this.listData.length < 6) {
                conut.data.body.splice(1, 1);
            }
            this.numList = conut.data.body;
        }
    },
    watch: {
        num: {
            handler(o, v) {
                cGoBack();
            },
            deep: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/page/selectSkin/selectSkin.vue